import { useEffect, useState } from 'react';

export const useMediaQuery = (query: string): boolean => {
  const get = (): boolean =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia(query).matches
      : false;
  const [matches, setMatches] = useState<boolean>(get);
  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const m = window.matchMedia(query);
    const cb = (e: MediaQueryListEvent): void => setMatches(e.matches);
    setMatches(m.matches);
    m.addEventListener('change', cb);
    return () => m.removeEventListener('change', cb);
  }, [query]);
  return matches;
};

export const useIsLgUp = (): boolean => useMediaQuery('(min-width: 1024px)');
